import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './participate.css';

function Participate() {
  const [salutation, setSalutation] = useState('Dr.');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [country, setCountry] = useState('');
  const [description, setDescription] = useState('');
  const [consentList, setConsentList] = useState(false);
  const [consentPrivacy, setConsentPrivacy] = useState(false);
  const [listOnWebsite, setListOnWebsite] = useState('Yes');
  const navigate = useNavigate();

  const handleSalutationChange = (e) => {
    setSalutation(e.target.value);
  };

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleConfirmEmailChange = (e) => {
    setConfirmEmail(e.target.value);
  };

  const handleCountryChange = (e) => {
    setCountry(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleConsentListChange = (e) => {
    setConsentList(e.target.checked);
  };

  const handleConsentPrivacyChange = (e) => {
    setConsentPrivacy(e.target.checked);
  };

  const handleListOnWebsiteChange = (e) => {
    setListOnWebsite(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation logic
    if (
      !firstName ||
      !lastName ||
      !email ||
      !confirmEmail ||
      email !== confirmEmail ||
      !country ||
      !description ||
      !consentList ||
      !consentPrivacy
    ) {
      alert('Please fill in all required fields and ensure emails match.');
      return;
    }

    // Navigate to Payment Page with User Data
    navigate('/payment', {
      state: {
        salutation,
        firstName,
        lastName,
        email,
        country,
        description,
      },
    });
  };

  return (
    <>
      <div className="registration-form-container">
        <h2 className="form-title">Application</h2>
        <p className='intro-text'>
          The Diyatharippu International Optometric Conference offers a valuable opportunity for professionals in the field of optometry to expand their knowledge, network with peers, and stay abreast of the latest advancements. To participate in this esteemed event, interested individuals are required to register by providing relevant details.
        </p>

        <h3 className="applicant-header">Applicant Information</h3>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="salutation">Salutation</label>
            <select id="salutation" value={salutation} onChange={handleSalutationChange}>
              <option value="Dr.">Dr.</option>
              <option value="Prof.">Prof.</option>
              <option value="Mr.">Mr.</option>
              <option value="Mrs.">Mrs.</option>
              <option value="Ms.">Ms.</option>
            </select>
          </div>

          <div className="input-group">
            <label htmlFor="firstName">First Name</label>
            <input
              type="text"
              id="firstName"
              value={firstName}
              onChange={handleFirstNameChange}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="lastName">Last Name</label>
            <input
              type="text"
              id="lastName"
              value={lastName}
              onChange={handleLastNameChange}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={handleEmailChange}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="confirmEmail">Confirm Email</label>
            <input
              type="email"
              id="confirmEmail"
              value={confirmEmail}
              onChange={handleConfirmEmailChange}
              required
            />
          </div>

          <div className="input-group">
            <label htmlFor="country">Country</label>
            <input
              type="text"
              id="country"
              value={country}
              onChange={handleCountryChange}
              required
            />
          </div>

          <div className="radio-group">
            <label>Please select which best describes you.</label>
            <div>
              <label>
                <input
                  type="radio"
                  value="Optometrist"
                  checked={description === 'Optometrist'}
                  onChange={() => setDescription('Optometrist')}
                />
                Optometrist
              </label>
              <label>
                <input
                  type="radio"
                  value="Faculty"
                  checked={description === 'Faculty'}
                  onChange={() => setDescription('Faculty')}
                />
                Faculty
              </label>
              <label>
                <input
                  type="radio"
                  value="Administrator"
                  checked={description === 'Administrator'}
                  onChange={() => setDescription('Administrator')}
                />
                Administrator
              </label>
              <label>
                <input
                  type="radio"
                  value="Other"
                  checked={description === 'Other'}
                  onChange={() => setDescription('Other')}
                />
                Other
              </label>
            </div>
          </div>

          <div className="checkbox-group-participate">
            <label>
              I have read and agree to the Diyatharippu International Optometric Conference's Terms and Conditions.
              <input
                type="checkbox"
                checked={consentList}
                onChange={handleConsentListChange}
              />
            </label>
            <a href="/termsandconditions" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
          </div>

          <div className="checkbox-group-participate">
            <label>
              I have read and agree to the Diyatharippu International Optometric Conference's Privacy Policy.
              <input
                type="checkbox"
                checked={consentPrivacy}
                onChange={handleConsentPrivacyChange}
              />
            </label>
            <a href="/privacyandpolicies" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          </div>

          <button type="submit" className="submit-button">Submit</button>
        </form>
      </div>
    </>
  );
}

export default Participate;
